import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import './checks.scss'

const CheckCeis = ({ ceisCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])
  const hasChecks = Array.isArray(ceisCheck?.checkDetails) && ceisCheck?.checkDetails?.length > 0
  const checkLength =!ceisCheck.found ? 0 : ceisCheck?.checkDetails?.length || 0;

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:ceis')}</Typography>

        <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} />
      </Paper>
      <CheckDetailTitle
        email={ceisCheck?.email}
        status={ceisCheck?.status}
        createdAt={ceisCheck?.createdAt}
        updatedAt={ceisCheck?.updatedAt}
      />
      {!Array.isArray(ceisCheck?.checkDetails) && ceisCheck?.checkDetails?.informação && (
        <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
          <Typography variant="subtitle1">{t('common:information')}</Typography>
          <Typography variant="subtitle3">{ceisCheck.checkDetails.informação ?? '---'}</Typography>
        </Paper>
      )}
      {hasChecks &&
        ceisCheck.checkDetails.map((element, index) => (
          <TimelineDotLine key={index}>
            <Paper
              elevation={0}
              sx={{
                flex: 1,
              }}
              variant="rootOutlined"
            >
              <div className="c-detail-grid">
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:initialDate')}</Typography>
                  <Typography variant="subtitle3">{element.dataInicioSancao ?? '---'}</Typography>
                </div>
                <div className="c-detail-row">
                  <Typography variant="subtitle1">{t('common:endDate')}</Typography>
                  <Typography variant="subtitle3">{element.dataFimSancao ?? '---'}</Typography>
                </div>
                <div className="c-detail-col">
                  <Typography variant="subtitle1">{t('common:sanctionDescription')}</Typography>
                  <Typography variant="subtitle3">{element.tipoSancao?.descricaoResumida ?? '---'}</Typography>
                </div>
                <div className="c-detail-col">
                  <Typography variant="subtitle1">{t('common:sanctioningBody')}</Typography>
                  <Typography variant="subtitle3">{element.orgaoSancionador?.nome ?? '---'}</Typography>
                </div>
              </div>
            </Paper>
          </TimelineDotLine>
        ))}
    </>
  )
}

export default CheckCeis

/* const CheckCeis = ({ title = '', ceisCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])
  return (
    <Box className="detail-group">
      <Typography variant={variantByLevel[level] || variantByLevel[0]}>{title || 'CEIS'}</Typography>
      <CheckDetailTitle
        email={ceisCheck?.email}
        status={ceisCheck?.status}
        createdAt={ceisCheck?.createdAt}
        updatedAt={ceisCheck?.updatedAt}
      />
      {!Array.isArray(ceisCheck?.checkDetails) && ceisCheck?.checkDetails?.informação && (
        <Box>
          <span>{t('common:information')}</span>
          <p>{ceisCheck?.checkDetails?.informação ?? '---'}</p>
        </Box>
      )}
      {Array.isArray(ceisCheck?.checkDetails) && ceisCheck?.checkDetails?.length && (
        <Box>
          <h4>{t('common:sanctions')}</h4>
          <Box className="group-table">
            <table className="bs bst group-table">
              <thead>
                <tr className="group-table">
                  <th className="bs">{t('common:initialDate')}</th>
                  <th className="bs">{t('common:endDate')}</th>
                  <th className="bs">{t('common:sanctionDescription')}</th>
                  <th className="bs">{t('common:sanctioningBody')}</th>
                </tr>
              </thead>
              <tbody>
                {ceisCheck?.checkDetails?.map((element, index) => {
                  return (
                    <tr className="group-table" key={index}>
                      <td className="bs table-cell col-4">{element.dataInicioSancao ?? '---'}</td>
                      <td className="bs table-cell col-4">{element.dataFimSancao ?? '---'}</td>
                      <td className="bs table-cell col-4">{element.tipoSancao?.descricaoResumida ?? '---'}</td>
                      <td className="bs table-cell col-4">{element.orgaoSancionador?.nome ?? '---'}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default CheckCeis
 */
